import React, { useEffect } from "react";
import { Container, Button } from "react-bootstrap";
import { useLocation, useNavigate, Link } from "react-router-dom";
import Row from 'react-bootstrap/Row';
import DonateBanner from "./DonateBanner";
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';


// Footer Component
const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <footer className="bg-success footer-custom py-2 py-md-2">
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-center text-center text-md-start">
        
      {/* Left: Copyright */}
      <div className="mb-1 mb-md-0 small ps-2">
        &copy; {new Date().getFullYear()} teachers-app.com. All Rights Reserved.
      </div>

    {/* Right: Footer links */}
    <div className="mt-1 mt-md-0 small pe-2">
      {location.pathname === "/terms-of-use" || location.pathname === "/privacy-policy" ? (
        <></>
      ) : location.pathname !== "/" &&
        location.pathname !== "/register" &&
        location.pathname !== "/forgot-username" &&
        location.pathname !== "/forgot-password" &&
        location.pathname !== "/reset-password" ? (
        <>
          <Link to="/terms-of-use" target="_blank" className="text-decoration-none footer-links pe-1">
            Όροι χρήσης
          </Link> |{" "}
          <Link to="/privacy-policy" target="_blank" className="text-decoration-none footer-links ps-1 pe-1">
            Προστασία Δεδομένων (GDPR)
          </Link> |{" "}
          <Link to="/contact-support" className="text-decoration-none footer-links ps-1">
            Επικοινωνία
          </Link>
        </>
      ) : (
        <>
          <Link to="/terms-of-use" target="_blank" className="text-decoration-none footer-links pe-1">
            Όροι χρήσης
          </Link> |{" "}
          <Link to="/privacy-policy" target="_blank" className="text-decoration-none footer-links ps-1">
            Προστασία Δεδομένων (GDPR)
          </Link>
        </>
      )}
    </div>

  </div>
</footer> 

  );
};
  
// Header Component
const Header = ({ handleLogout }) => {
  const location = useLocation();
  const navigate = useNavigate();
  

  const pageTitles = {
    "/": "Είσοδος",
    "/main": "Χρήσιμα εργαλεία για αναπληρωτές",
    "/ranking-per-state": "Αριθμός προσλήψεων ανά ημερομηνία πρόσληψης",
    "/ranking-per-score": "Έλεγχος περιοχων βάσει θέσης πίνακα",
    "/ranking-personal-details": "Εύρεση θέσης πίνακα",
    "/appointment-date": "Ημερομηνία πρόσληψης βάσει σειράς πίνακα",
    "/ranking-above-me": "Συνολικός αριθμός ανθρώπων που προηγούνται",
    "/rent-prices": "Τιμές ενοικίου",
    "/register": "Εγγραφή χρήστη",
    "/historical-data": "Ιστορικά δεδομένα προσλήψεων",
    "/transfers": "Μεταθέσεις εκπαιδευτικών",
    "/contact-support": "Φόρμα επικοινωνίας",
    "/forgot-username": "Υπενθύμιση ονόματος χρήστη",
    "/forgot-password": "Υπενθύμιση κωδικού πρόσβασης",
    "/reset-password": "Επαναφορά κωδικού πρόσβασης",
    "/historical-data-appointments": "Ιστορικά δεδομένα διορισμών"
  };

  const handleButtonClick = () => {
    if (location.pathname === '/register' || location.pathname === '/forgot-username'|| location.pathname === '/forgot-password' || location.pathname === '/reset-password') {
      navigate('/');
    } else {
      handleLogout();
    }
  };

  const handleMainPageClick = () => {
    navigate('/main');
  };

  const currentTitle = pageTitles[location.pathname];
  const version = process.env.REACT_APP_LAST_UPDATE;

  return (
    <header >
  <div className="bg-success header-custom py-2 py-md-3">
    <Container className="d-flex flex-column flex-md-row justify-content-between align-items-center text-center text-md-start">
      
      {/* Mobile: Icons row (left & right) */}
      <div className="d-flex justify-content-between w-100 d-md-none">
        {/* Left Icon: Αρχική */}
        <div style={{ minWidth: "48px" }}>
          {location.pathname !== '/main' &&
            location.pathname !== '/' &&
            location.pathname !== '/register' &&
            location.pathname !== '/forgot-username' &&
            location.pathname !== '/forgot-password' &&
            location.pathname !== '/reset-password' && (
              <Button
                size="sm"
                variant="danger"
                className=""
                onClick={handleMainPageClick}
                title="Αρχική"
              >
                <i className="bi bi-house"></i>
              </Button>
          )}
        </div>


        {/* Right Icon: Αποσύνδεση */}
        <div style={{ minWidth: "48px" }}>
          {location.pathname !== '/' && (
            <Button
              size="sm"
              variant="danger"
              className=""
              onClick={handleButtonClick}
              title={
                ['/register', '/forgot-username', '/forgot-password', '/reset-password'].includes(location.pathname)
                  ? 'Επιστροφή στην αρχική'
                  : 'Αποσύνδεση'
              }
            >
              <i className={
                ['/register', '/forgot-username', '/forgot-password', '/reset-password'].includes(location.pathname)
                  ? 'bi bi-arrow-left-circle'
                  : 'bi bi-power'
        }></i>
            </Button>
          )}
        </div>
      </div>

      {/* Mobile: Title and version centered below icons */}
      <div className="mt-2 d-md-none">
        <h6 className="text-info-emphasis m-0">{currentTitle}</h6>
        <small className="text-white-60">Τελευταία ενημέρωση: {version}</small>
      </div>

      {/* Desktop Left: Αρχική button */}
      <div className="d-none d-md-block mb-0" style={{ minWidth: "128px" }}>
        {location.pathname !== '/main' &&
          location.pathname !== '/' &&
          location.pathname !== '/register' &&
          location.pathname !== '/forgot-username' &&
          location.pathname !== '/forgot-password' &&
          location.pathname !== '/reset-password' && (
            <Button
              size="sm"
              onClick={handleMainPageClick}
              variant="danger"
              className="me-md-2"
            >
              Αρχική
            </Button>
        )}
      </div>

      {/* Desktop Center: Title and version */}
      <div className="d-none d-md-block flex-grow-1 text-center">
        <h6 className="text-info-emphasis m-0">{currentTitle}</h6>
        <small className="text-white-60">Τελευταία ενημέρωση: {version}</small>
      </div>

      {/* Desktop Right: Αποσύνδεση or Επιστροφή */}
      <div className="d-none d-md-block" style={{ minWidth: "128px" }}>
        {location.pathname !== '/' && (
          <Button
            size="sm"
            onClick={handleButtonClick}
            variant="outline-danger"
          >
            {['/register', '/forgot-username', '/forgot-password', '/reset-password'].includes(location.pathname)
              ? 'Επιστροφή στην αρχική'
              : 'Αποσύνδεση'}
          </Button>
        )}
      </div>
    
    </Container>
  </div>
      <DonateBanner />
  
</header>

  );
};

// Export Components
export { Footer, Header };